import { useState, useRef, useContext } from "react";
// import { FcGoogle } from "react-icons/fc";
// import { FaMicrosoft } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { Context } from "../context/Context";

const Auth = () => {
  const navigate = useNavigate();

  const [showOtp, setShowOtp] = useState(false);
  const [isLogin, setIsLogin] = useState(true);
  const [loading, setLoading] = useState(false);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [showPassword, setShowPassword] = useState(false);

  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const inputs = useRef([]);

  const { setAuth } = useContext(Context);
  // SEND OTP
  const handleSubmit = async () => {
    if (!name || !email || !password) {
      return alert("Fill all fields");
    }

    try {
      setLoading(true);

      const res = await fetch("https://api.clinicalaiassistance.com/api/user/sendOTP", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          password,
        }),
      });

      const data = await res.json();

      if (data.success) {
        setShowOtp(true);
      }

      alert(data.message);
    } catch (error) {
      console.log(error);
      alert("Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  // LOGIN
  const handleLogin = async () => {
    if (!email || !password) {
      return alert("Enter email and password");
    }

    try {
      setLoading(true);

      const res = await fetch("https://api.clinicalaiassistance.com/api/user/login", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          password,
        }),
      });

      const data = await res.json();

      if (data.success) {
        localStorage.setItem("token", data.token);
        setAuth(localStorage.getItem("token"));
        localStorage.setItem("user", JSON.stringify(data.user));
        alert("Login Successful");
        navigate("/auth");
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
      alert("Login failed");
    } finally {
      setLoading(false);
    }
  };

  // OTP CHANGE
  const handleChange = (value, index) => {
    if (!/^[0-9]?$/.test(value)) return;

    const newOtp = [...otp];
    newOtp[index] = value;
    setOtp(newOtp);

    if (value && index < 5) {
      inputs.current[index + 1].focus();
    }
  };

  // BACKSPACE
  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace" && !otp[index] && index > 0) {
      inputs.current[index - 1].focus();
    }
  };

  // VERIFY OTP
  const handleVerify = async () => {
    const finalOtp = otp.join("");

    if (finalOtp.length !== 6) {
      return alert("Enter complete OTP");
    }

    try {
      setLoading(true);

      const res = await fetch("https://api.clinicalaiassistance.com/api/user/verifyOTP", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          password,
          otp: finalOtp,
        }),
      });

      const data = await res.json();

      if (data.success) {
        alert("Login Successful");
        localStorage.setItem("token", data.token);
        setAuth(localStorage.getItem("token"));
        localStorage.setItem("user", JSON.stringify(data.user));
        navigate("/auth");
      } else {
        alert(data.message);
      }
    } catch (error) {
      console.log(error);
      alert("Verification failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-white dark:bg-black px-4">
      <div className="w-full max-w-md sm:max-w-lg border border-gray-200 dark:border-white/10 rounded-xl p-4 sm:p-8 bg-white dark:bg-[#0d0d0d] shadow-lg">
        {/* Logo */}
        <div className="flex flex-col items-center mb-8">
          <div className="w-10 h-10 border border-gray-400 dark:border-gray-500 rounded-full flex items-center justify-center mb-3">
            <span className="text-xl text-black dark:text-white"><img src="../img/logoDarkUpdated.png" alt="Logo" /></span>
          </div>

          <h1 className="text-2xl font-semibold text-black dark:text-white">
            Clinical AI Assistance{" "}
            {/* <span className="text-gray-500 text-sm">AI</span> */}
          </h1>
        </div>

        {/* SIGNUP CARD */}
        {!showOtp && !isLogin && (
          <>
            {/* <button className="w-full flex items-center justify-center gap-3 border border-gray-300 dark:border-white/10 py-3 rounded-lg mb-4 hover:bg-gray-100 dark:hover:bg-white/10 transition">
              <FcGoogle size={20} />
              <span className="text-black dark:text-white">Google Account</span>
            </button>

            <button className="w-full flex items-center justify-center gap-3 border border-gray-300 dark:border-white/10 py-3 rounded-lg mb-6 hover:bg-gray-100 dark:hover:bg-white/10 transition">
              <FaMicrosoft size={18} />
              <span className="text-black dark:text-white">
                Outlook Account
              </span>
            </button> */}

            {/* <div className="flex items-center gap-3 mb-6">
              <div className="flex-1 h-px bg-gray-300 dark:bg-white/10"></div>
              <span className="text-sm text-gray-500">OR</span>
              <div className="flex-1 h-px bg-gray-300 dark:bg-white/10"></div>
            </div> */}

            {/* Name */}
            <input
              type="text"
              placeholder="First Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full px-4 py-3 mb-4 rounded-lg border border-gray-300 dark:border-white/10 bg-white dark:bg-black text-black dark:text-white outline-none"
            />

            {/* Email */}
            <input
              type="email"
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 mb-4 rounded-lg border border-gray-300 dark:border-white/10 bg-white dark:bg-black text-black dark:text-white outline-none"
            />

            {/* Password */}
            <div className="relative mb-4">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-white/10 bg-white dark:bg-black text-black dark:text-white outline-none"
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-5 cursor-pointer text-gray-500"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button
              onClick={handleSubmit}
              className="w-full py-3 bg-black dark:bg-white text-white dark:text-black rounded-lg"
            >
              {loading ? "Sending..." : "Send OTP"}
            </button>
          </>
        )}

        {/* LOGIN CARD */}
        {isLogin && (
          <div className="flex flex-col gap-4">
            <input
              type="email"
              placeholder="Email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-white/10 bg-white dark:bg-black text-black dark:text-white outline-none"
            />

            <div className="relative">
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-gray-300 dark:border-white/10 bg-white dark:bg-black text-black dark:text-white outline-none"
              />

              <span
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-3 cursor-pointer text-gray-500"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </span>
            </div>

            <button
              onClick={handleLogin}
              className="w-full py-3 bg-black dark:bg-white text-white dark:text-black rounded-lg"
            >
              {loading ? "Logging in..." : "Login"}
            </button>

            <p
              onClick={() => setIsLogin(false)}
              className="text-sm text-gray-500 underline text-center cursor-pointer"
            >
              Create new account
            </p>
          </div>
        )}

        {/* OTP CARD */}
        {showOtp && (
          <div className="flex flex-col gap-6">
            <div className="text-center">
              <p className="text-gray-500 text-sm">Enter OTP sent to</p>

              <p className="font-semibold text-black dark:text-white">
                {email}
              </p>
            </div>

            <div className="flex justify-between gap-2">
              {otp.map((digit, index) => (
                <input
                  key={index}
                  ref={(el) => (inputs.current[index] = el)}
                  type="text"
                  maxLength="1"
                  value={digit}
                  onChange={(e) => handleChange(e.target.value, index)}
                  onKeyDown={(e) => handleKeyDown(e, index)}
                  className="w-12 h-12 text-center text-lg border rounded-lg border-gray-400 bg-white dark:bg-black text-black dark:text-white outline-none focus:ring-2 focus:ring-gray-400"
                />
              ))}
            </div>

            <button
              onClick={handleVerify}
              className="w-full py-3 bg-black dark:bg-white text-white dark:text-black rounded-lg"
            >
              {loading ? "Verifying..." : "Verify OTP"}
            </button>

            <button
              onClick={() => setShowOtp(false)}
              className="text-sm text-gray-500 underline text-center"
            >
              Change Email
            </button>
          </div>
        )}

        {/* Bottom Links */}
        <div className="mt-6 flex justify-between text-sm text-gray-500">
          <p
            onClick={() => navigate("/")}
            className="hover:underline cursor-pointer"
          >
            ← Back to landing page
          </p>

          {!isLogin && (
            <p
              onClick={() => setIsLogin(true)}
              className="hover:underline cursor-pointer"
            >
              Already have an account?
            </p>
          )}
        </div>

        <p className="mt-4 text-xs text-center text-gray-500 leading-relaxed">
          By signing in you are agreeing to our
          <span onClick={() => navigate("/TermsAndConditions")} className="underline cursor-pointer"> Terms of Service </span>
          and
          <span onClick={() => navigate("/TermsAndConditions")} className="underline cursor-pointer"> Privacy Policy</span>
        </p>
      </div>
    </div>
  );
};

export default Auth;
